export enum TypeSearchClientByPassport {
  CHANGES = 'CHANGES',
  CLIENT = 'CLIENT'
}
